import {
  BulkSettlementCreateFor,
  InvoiceCategoryFilter,
} from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

export const bulkSettlementEntityTypes = {
  [BulkSettlementCreateFor.CUSTOMERS]: {
    category: InvoiceCategoryFilter.RECEIVABLES,
    labelKey: 'form_fields.customer',
    menuLabelKey: 'approvals.files.bulk_customer_settlements',
    menuPosition: 3,
  },
  [BulkSettlementCreateFor.DRIVERS]: {
    category: InvoiceCategoryFilter.PAYABLES,
    labelKey: 'form_fields.driver',
    menuLabelKey: 'approvals.files.bulk_driver_settlements',
    menuPosition: 2,
  },
  [BulkSettlementCreateFor.VENDORS]: {
    category: InvoiceCategoryFilter.PAYABLES,
    labelKey: 'form_fields.vendor',
    menuLabelKey: 'approvals.files.bulk_vendor_settlements',
    menuPosition: 1,
  },
} satisfies Record<
  BulkSettlementCreateFor,
  {
    category: InvoiceCategoryFilter;
    labelKey: string;
    menuLabelKey: string;
    menuPosition: number;
  }
>;

export const BULK_SETTLEMENT_ENTITY_TYPES_IN_MENU_ORDER = Object.values(
  BulkSettlementCreateFor,
).sort(
  (firstEntityType, secondEntityType) =>
    bulkSettlementEntityTypes[firstEntityType].menuPosition -
    bulkSettlementEntityTypes[secondEntityType].menuPosition,
);

export function getBulkSettlementEntityTypesOfCategory(category: InvoiceCategoryFilter) {
  return BULK_SETTLEMENT_ENTITY_TYPES_IN_MENU_ORDER.filter(
    (entityType) => bulkSettlementEntityTypes[entityType].category === category,
  );
}

export function getBulkSettlementEntityTypeOption(entityType: BulkSettlementCreateFor) {
  return { label: t(bulkSettlementEntityTypes[entityType].labelKey), value: entityType };
}
